import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios' ;
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path:'/',
    name: 'app',
    component: () => import(/* webpackChunkName: "pages.home" */ '../App.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/index' : '/TPGovEReceipt/index',
    name: 'home',
    component: () => import(/* webpackChunkName: "pages.home" */ '../pages/Home.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/login' : '/TPGovEReceipt/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "pages.auth" */ '../pages/LoginTaipeiPass.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/householdInquiry' : '/TPGovEReceipt/householdInquiry',
    name: 'householdInquiry',
    component: () => import(/* webpackChunkName: "pages.HouseholdInquiry" */ '../pages/HouseholdInquiry.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/holdReceipt' : '/TPGovEReceipt/holdReceipt',
    name: 'holdReceipt',
    component: () => import(/* webpackChunkName: "pages.result" */ '../pages/Result.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/details' : '/TPGovEReceipt/details',
    name: 'details',
    component: () => import(/* webpackChunkName: "pages.details" */ '../pages/Details.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/upload-result' : '/TPGovEReceipt/upload-result',
    name: 'upload-result',
    component: () => import(/* webpackChunkName: "pages.upload-result" */ '../pages/UploadResult.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/householdInquiryInside' : '/TPGovEReceipt/householdInquiryInside',
    name: 'householdInquiryInside',
    component: () => import(/* webpackChunkName: "pages.HouseholdInquiryInside" */ '../pages/HouseholdInquiryInside'),
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import(/* webpackChunkName: "pages.announcement" */ '../pages/Announcement.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/resultTaipeiPASS' : '/TPGovEReceipt/resultTaipeiPASS',
    name: 'resultTaipeiPASS',
    component: () => import(/* webpackChunkName: "pages.resultTaipeiPASS" */ '../pages/ResultTaipeiPASS.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/taipeiPassApp/show' : '/TPGovEReceipt/Taipeipass/show',
    name: 'tpassDetail',
    component: () => import(/* webpackChunkName: "pages.tpassDetail" */ '../pages/TpassDetail.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/taipeiPassAppReturnHome/show' : '/TPGovEReceipt/taipeiPassAppReturnHome/show',
    name: 'taipeiPassAppReturnHome',
    component: () => import(/* webpackChunkName: "pages.tpassDetail" */ '../pages/TpassDetailReturnHome.vue'),
  },
  // {
  //   path: process.env.NODE_ENV === 'production' ? '/taipeiPassAppReturnHome/show' : '/TPGovEReceipt/taipeiPassAppReturnHome/show',
  //   name: 'tpassDetail',
  //   component: () => import(/* webpackChunkName: "pages.tpassDetail" */ '../pages/TpassDetail.vue'),
  // },
  // {
  //   path: process.env.NODE_ENV === 'production' ? '/taipeiPassApp/show' : '/TPGovEReceipt/taipeiPassApp/show',
  //   name: 'taipeiPassAppReturnHome',
  //   component: () => import(/* webpackChunkName: "pages.tpassDetail" */ '../pages/TpassDetailReturnHome.vue'),
  // },

  // 台北通新版
  {
    path: process.env.NODE_ENV === 'production' ? '/Taipeipass/receiptRecord' : '/TPGovEReceipt/Taipeipass/receiptRecord',
    name: 'taipeiPassAppReceiptRecord',
    component: () => import(/* webpackChunkName: "pages.tpassReceiptRecord" */ '../pages/TpassReceiptRecord.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/Taipeipass/receiptReturnHome' : '/TPGovEReceipt/Taipeipass/receiptReturnHome',
    name: 'taipeiPassAppReceiptReturnHome',
    component: () => import(/* webpackChunkName: "pages.tpassReceiptReturnHome" */ '../pages/TpassReceiptReturnHome.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/Taipeipass/receiptDetail' : '/TPGovEReceipt/Taipeipass/receiptDetail',
    name: 'taipeiPassAppReceiptDetail',
    component: () => import(/* webpackChunkName: "pages.tpassReceiptDetail" */ '../pages/TpassReceiptDetail.vue'),
  },
  {
    path: process.env.NODE_ENV === 'production' ? '/Taipeipass/receiptConfirmation' : '/TPGovEReceipt/Taipeipass/receiptConfirmation',
    name: 'taipeiPassAppReceiptConfirmation',
    component: () => import(/* webpackChunkName: "pages.tpassReceiptConfirmation" */ '../pages/TpassReceiptConfirmation.vue'),
  },
  {
    path: '*',
    redirect: {
      name: 'home',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

router.beforeEach(function(to, from, next) {
  console.log('to.name--', to.name);
  const method = 'post';
  if(to.name === 'app' || to.name === 'home'){
    console.log('我在首頁之前做');
    const url = '/TrafficControl/ClearanceService/Run';
    axios({
      url: url,
      method: method,
      data: {},
    })
      .then((res) => {
        if(res.data === 'Prohibit'){
          next({ name:'announcement' })
        } else {
          if(to.name === 'app'){
            next({ name: 'home' })
          }else{
            console.log('這裡嗎?')
            next()
            // next({ name: 'home' })
          }
        }
      })
      .catch((error) => {
        if(to.name === 'app'){
          next({ name: 'home' })
        }else{
          next()
        }
        // next({ name:'announcement' })
      });
  } else if(to.name === 'holdReceipt') {
    let url = '/GovEReceipt/FrontDeskService/QueryUser';
    const res = api(url, method, {})
    res.then((resData) => {
      if (resData.data === '') {
        console.log('未登入，走登入');
        url = '/GovEReceipt/UserLoginService/Login';
        const codeData = {
          code: to.query.code,
        };
        const loginRes = api(url, method, codeData)
        loginRes.then((resData) => {
          if (resData.ERROR) {
            console.log('CODE失效1-2-1');
            next({ name: 'home' })
          } else {
            console.log('CODE有效 有資本資料:1-2-2 ', resData);
            useData(resData.data.dataMessage, true);
            // next({ name:'holdReceipt' });
            next();
          }
        })
        .catch((error) => {
            useData({}, false);
            next({ name: 'home' })
        });

      } else {
        console.log('已登入');
        useData(resData.data.object.dataMessage, true);
        next();
        // next({ name:'holdReceipt' })
      }
    })
    .catch((error) => {
        useData({}, false);
        next({ name: 'home' })
    });

  }else if(to.name === 'details' || to.name === 'upload-result'){ // to.name === 'details' ||
    let queryLen = Object.keys(to.query).length;
    if(queryLen === 0 && !store.state.details.isDetailData){
      next({ name: 'home' })
    }else{
      next();
    }
  }else{
    console.log('其他');
    next();
  }

  // next();
});

export function api(url, method, data){
  return axios({
    url: url,
    method: method,
    data: data,
  })
}

// 存使用者資料
export function useData(UserData, isLogin){
  let changeUserData = {};
  console.log(' Object.keys(obj).length === 0',  Object.keys(UserData).length)
  let isEmpty = Object.keys(UserData).length === 0;
  if(!isEmpty){
    changeUserData = JSON.parse(UserData);
  }
  changeUserData.isLogin = isLogin;
  store.commit('login/changeLogin', changeUserData);
}

export default router;
